export default __webpack_public_path__ + "static/media/room-polen-3.ae85ee1c.webp";